import { render, staticRenderFns } from "./text-select.vue?vue&type=template&id=6360c74f&scoped=true"
import script from "./text-select.vue?vue&type=script&lang=js"
export * from "./text-select.vue?vue&type=script&lang=js"
import style0 from "./text-select.vue?vue&type=style&index=0&id=6360c74f&prod&lang=scss"
import style1 from "./text-select.vue?vue&type=style&index=1&id=6360c74f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6360c74f",
  null
  
)

export default component.exports